import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default createNumberMask({
  integerLimit:             3,
  prefix:                   '',
  suffix:                   ' hours',
  thousandsSeparatorSymbol: ''
});
